<div class="modal-overlay" *ngIf="showModal()" (click)="onClose()">
  <div class="modal-container" (click)="$event.stopPropagation()">
    <!-- Header Section -->
    <div class="modal-header">
      <div class="header-content">
        <div class="header-text">
          <h2 class="modal-title">History</h2>
          <p class="modal-subtitle">See the complete history for {{ modalData()?.fleetName }}.</p>
        </div>
        <button class="close-button" (click)="onClose()">
          <svg width="12" height="12" viewBox="0 0 12 12" fill="none">
            <path
              d="M9 3L3 9M3 3L9 9"
              stroke="#555963"
              stroke-width="2"
              stroke-linecap="round"
              stroke-linejoin="round"
            />
          </svg>
        </button>
      </div>

      <app-tab-header
        [tabs]="tabs"
        [activeTabId]="activeTab()"
        (tabChange)="onTabChange($event)"
      ></app-tab-header>
    </div>

    <!-- Content Section -->
    <div class="modal-content">
      <!-- Service History Tab -->
      <div class="service-history-tab" *ngIf="activeTab() === 'service'">
        <div class="stats-row">
          <div class="stat-card">
            <span class="stat-label">TOTAL VISITS</span>
            <span class="stat-value">{{ totalVisits() }}</span>
          </div>
          <div class="stat-card">
            <span class="stat-label">TOTAL VEHICLE</span>
            <span class="stat-value">{{ totalVehicles() }}</span>
          </div>
        </div>

        <p class="history-state" *ngIf="serviceHistoryLoading()">Loading service history…</p>

        <ng-container *ngIf="!serviceHistoryLoading()">
          <p class="history-state" *ngIf="vehicleRows().length === 0">No service history yet.</p>

          <div class="vehicle-table" *ngIf="vehicleRows().length > 0">
            <div class="vehicle-row vehicle-header">
              <span>License plate</span>
              <span>Package</span>
              <span>Last visited Date &amp; Time</span>
            </div>
            <div class="vehicle-row" *ngFor="let row of vehicleRows(); trackBy: trackByRowId">
              <span>{{ row.licensePlate }}</span>
              <span>{{ row.package }}</span>
              <span>{{ row.lastVisited }}</span>
            </div>
          </div>

          <app-pagination-bar
            *ngIf="totalItems() > 0"
            [paginationData]="paginationData()"
            testId="service-history"
            (pageChange)="onPageChange($event)"
            (itemsPerPageChange)="onItemsPerPageChange($event)"
          ></app-pagination-bar>
        </ng-container>
      </div>

      <!-- Edit History Tab -->
      <div class="edit-history-tab" *ngIf="activeTab() === 'edit'">
        <p class="history-state" *ngIf="editHistoryLoading()">Loading edit history…</p>

        <ng-container *ngIf="!editHistoryLoading()">
          <p class="history-state" *ngIf="editHistoryEntries().length === 0">
            No edit history yet.
          </p>

          <div class="timeline" *ngIf="editHistoryEntries().length > 0">
            <div
              class="timeline-item"
              *ngFor="let entry of editHistoryEntries(); trackBy: trackById"
            >
              <span class="timeline-dot" [class]="entry.status"></span>
              <div class="timeline-content">
                <div class="timeline-row">
                  <span class="timeline-title">{{ entry.title }}</span>
                  <span class="timeline-timestamp">{{ entry.timestamp }}</span>
                </div>
                <div class="detail-card" *ngIf="entry.details.length">
                  <div
                    class="detail-row"
                    *ngFor="let detail of entry.details; trackBy: trackByIndex"
                  >
                    <span class="detail-label">{{ detail.label }}</span>
                    <span class="detail-value">{{ detail.value }}</span>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </ng-container>
      </div>

      <!-- Email History Tab -->
      <div class="email-history-tab" *ngIf="activeTab() === 'email'">
        <p class="history-state" *ngIf="emailHistoryLoading()">Loading email history…</p>

        <ng-container *ngIf="!emailHistoryLoading()">
          <p class="history-state" *ngIf="emailHistoryCycles().length === 0">
            No invoice emails yet. Invoice emails are sent automatically when a billing cycle
            closes.
          </p>

          <ng-container *ngIf="emailHistoryCycles().length > 0">
            <div
              class="email-cycle"
              *ngFor="let cycle of emailHistoryCycles(); trackBy: trackByCycleId"
            >
              <div class="timeline-row">
                <div class="email-cycle-heading">
                  <span class="timeline-title">{{ cycle.billingCycle }}</span>
                  <span class="timeline-timestamp">{{ cycle.invoiceNumber }}</span>
                </div>
                <button
                  *ngIf="cycle.hasPdf"
                  type="button"
                  class="pdf-link"
                  [disabled]="openingPdfId() === cycle.invoiceId"
                  (click)="onOpenPdf(cycle)"
                >
                  {{ openingPdfId() === cycle.invoiceId ? 'Opening…' : 'View PDF' }}
                </button>
              </div>

              <div class="detail-card">
                <div
                  class="email-row"
                  *ngFor="let row of cycle.recipients; trackBy: trackByRecipientId"
                >
                  <span class="email-recipient" [title]="row.recipient">{{ row.recipient }}</span>
                  <span class="email-cell">
                    <span>{{ row.lastAttempt }}</span>
                    <span class="email-cell-meta">{{ row.attemptsLabel }}</span>
                  </span>
                  <span class="email-status">
                    <span class="status-badge" [ngClass]="'status-' + row.status">
                      {{ row.status === 'sent' ? 'Sent' : 'Failed' }}
                    </span>
                  </span>
                  <span class="email-error" *ngIf="row.error" [title]="row.error">
                    {{ row.error }}
                  </span>
                </div>
              </div>
            </div>

            <p class="history-hint">“Sent” means the email provider accepted the message.</p>

            <app-pagination-bar
              *ngIf="emailTotalItems() > emailItemsPerPage()"
              [paginationData]="emailPaginationData()"
              testId="email-history"
              (pageChange)="onEmailPageChange($event)"
              (itemsPerPageChange)="onEmailItemsPerPageChange($event)"
            ></app-pagination-bar>
          </ng-container>
        </ng-container>
      </div>
    </div>

    <!-- Footer Section -->
    <div class="modal-footer">
      <div class="footer-buttons">
        <button class="btn btn-secondary" (click)="onClose()">Close</button>
        <button class="btn btn-primary" (click)="onOkay()">Okay</button>
      </div>
    </div>
  </div>
</div>
